import type { SVGProps } from 'react';
export const SvgTwitter = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={20}
		height={20}
		fill="currentColor"
		viewBox="0 0 20 20"
		{...props}
	>
		<path d="M18.333 4.913a7.1 7.1 0 0 1-1.943.55 3.4 3.4 0 0 0 1.495-1.872 6.8 6.8 0 0 1-2.168.808q-1.009-1.065-2.54-1.065-1.384 0-2.392.991-1.01.992-1.01 2.388 0 .367.113.771a10.1 10.1 0 0 1-3.961-1.028 9.9 9.9 0 0 1-3.102-2.498 3.3 3.3 0 0 0-.448 1.69q0 .88.41 1.616.412.735 1.084 1.175a3.2 3.2 0 0 1-1.532-.404v.037q0 1.212.785 2.13a3.5 3.5 0 0 0 1.943 1.176 3.5 3.5 0 0 1-.897.11q-.299 0-.635-.074a3.43 3.43 0 0 0 1.196 1.69 3.6 3.6 0 0 0 1.98.661q-1.83 1.433-4.222 1.433-.411 0-.822-.037a9.63 9.63 0 0 0 5.231 1.506q2.99 0 5.307-1.506 2.13-1.323 3.326-3.6 1.12-2.166 1.12-4.444l-.037-.441a6.5 6.5 0 0 0 1.72-1.763" />
	</svg>
);
